var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 82,
    viewBox: "0 0 216 82",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.2 43.97C71.189 63.645 87.8 79 108 79c21.54 0 39-17.46 39-39S129.54 1 108 1C95.305 1 84.027 7.066 76.905 16.457 73.53 15.294 71.138 12.394 71.138 9c0-4.418 4.053-8 9.054-8h126.754c5 0 9.054 3.582 9.054 8s-4.054 8-9.054 8H155.21c5 0 9.053 3.582 9.053 8s-4.053 8-9.053 8h28.455c5 0 9.054 3.582 9.054 8s-4.054 8-9.054 8h-13.16c-6.304 0-11.415 3.582-11.415 8 0 2.946 2.587 5.612 7.76 8 5 0 9.054 3.582 9.054 8s-4.053 8-9.054 8H59.497c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8H9.054C4.054 65 0 61.418 0 57s4.054-8 9.054-8H60.79c3.813 0 7.075-2.082 8.41-5.03Zm-.136-6.224C67.654 34.95 64.479 33 60.79 33H28.455c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8h48.046a38.798 38.798 0 0 0-7.437 20.746ZM206.946 49c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8S216 36.582 216 41s-4.054 8-9.054 8Z",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#6A6666",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(69 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 39,
    r: 39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.483 59c6.707-.01 10.869-1.197 12.484-3.56 1.524-2.23.911-8.082.911-11.012 0-5.49-2.642-12.428-7.682-12.428-2.343 0-3.757 1.884-5.8 1.884-2.124 0-3.583-1.884-5.829-1.784-4.955.22-7.48 6.919-7.48 12.328 0 3-.536 8.753 1.055 11.012 1.622 2.303 5.736 3.49 12.34 3.56Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 25,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 78C17.46 78 0 60.54 0 39S17.46 0 39 0s39 17.46 39 39-17.46 39-39 39Zm1-47a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.483 61c6.707-.01 10.869-1.197 12.484-3.56 1.524-2.23.911-8.082.911-11.012 0-5.49-2.642-12.428-7.682-12.428-2.343 0-3.757 1.884-5.8 1.884-2.124 0-3.583-1.884-5.829-1.784-4.955.22-7.48 6.919-7.48 12.328 0 3-.536 8.753 1.055 11.012 1.622 2.303 5.736 3.49 12.34 3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 80c-21.54 0-39-17.46-39-39S86.46 2 108 2s39 17.46 39 39-17.46 39-39 39Zm1-47a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.481cb67958ebd9c0daabc65736efcaab.svg";
export { ForwardRef as ReactComponent };